
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionFranchiseType,
    CollectionFranchisePayloadType,
} from "@/common/types/collection-franchise";

export async function collectionFranchiseList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/franchise/list${queryString}`
    );
}

export async function collectionFranchiseGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/franchise/${item_id}/show`
    );
}

export async function collectionFranchiseCreate(
    collection_id: string,
    payload: CollectionFranchisePayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/franchise/create`,
        payload
    );
}

export async function collectionFranchisePatch(
    item_id: string,
    payload: Partial<CollectionFranchiseType>
) {
    return await clientAxios.patch(
        `collection/franchise/${item_id}/patch`,
        { payload }
    );
}

export async function collectionFranchiseDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/franchise/${item_id}/delete`,
    );
}
